<agpr-dialog-container
    [id]="id"
    heading="Briefings.analysis.generatingAnalysis"
    [showLoadingHeader]="true"
    [contentPadding]="true"
    (close)="cancel()"
>
    <agpr-message
        [id]="id + '_message'"
        [severity]="messageSeverityEnum.info"
    >
        <div [innerHtml]="'Briefings.analysis.generatingAnalysis.processing' | localize"></div>
    </agpr-message>

    <ng-template #footerLeft>
        <agpr-button
            [id]="id + '_cancel'"
            label="Core.button.cancel"
            (click)="cancel()"
            [style]="buttonTypesEnum.secondary"
        ></agpr-button>
    </ng-template>
</agpr-dialog-container>